import '../../style/';
import './index.less';



// WEBPACK FOOTER //
// ./components/badge/style/index.tsx